// @flow

import { chatHiddenCls } from 'shared_styles/app.less';

/**
 * toggleChat
 *
 * @param {boolean} hide
 * @returns void
 */
export function toggleChat(hide: boolean = false): void {
  const classList = (document && document.body && document.body.classList) || null;

  if (classList) {
    hide ? classList.add(chatHiddenCls) : classList.remove(chatHiddenCls);
  }
}
